import { downloadZip as downloadZipFile } from "client-zip";

import { saveBlob } from "./save-file";

export interface IFile {
  name: string;
  input: Blob;
}

export const downloadZip = async (files: IFile[], name: string): Promise<boolean> => {
  const zipBlob = await downloadZipFile(files).blob();
  return saveBlob(zipBlob, name, "application/zip");
};
